import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const HoverStateToolTip = ({ isFavorited, isRightJustified, theme }) => {
  const label = `Add${isFavorited ? 'ed' : ''} to Watchlist`;
  return (
    <div
      className={classNames([
        theme.hoverStateToolTip,
        theme.watchListToolTip,
        isRightJustified && theme.hoverStateToolTipRight,
      ])}
    >
      <div className={theme.hoverStateToolTipLabel}>{label}</div>
      <div className={theme.hoverStateToolTipTip} />
    </div>
  );
};

export default HoverStateToolTip;

HoverStateToolTip.propTypes = {
  isFavorited: PropTypes.bool,
  theme: PropTypes.shape({}),
  isRightJustified: PropTypes.bool,
};

HoverStateToolTip.defaultProps = {
  isFavorited: false,
  theme: {},
  isRightJustified: false,
};
